<script setup lang="ts">
import { computed } from 'vue';

import VDialog from '@components/dialogs/VDialog/VDialog.vue';
import { useLocale } from '@modules/i18n/composables';

const visible = defineModel<boolean>('visible');

const { currentLocale } = useLocale();

const title = computed(() => currentLocale.value === 'ru_RU' ? 'Описание версий' : 'Version description');
</script>

<template>
  <VDialog
    v-model:visible="visible"
    :title="title"
  >
    <div v-if="currentLocale === 'ru_RU'">
      <p>
        <strong>Version 1</strong>
        <br>
        <br>
      </p>
      <ul class="list-disc pl-8">
        <li>
          Расчет RS зависит от того, NGR какого продукта указан в сделке: <strong>NGR Casino, NGR Sportsbook </strong>или<strong> общий NGR (NGR Casino + NGR Sportsbook)</strong>.
        </li>
        <li>
          Фиксированные коэффициенты платформы для <strong>Casino</strong> и <strong>Sportsbook</strong>.
        </li>
        <li>
          Нет отдельных комиссий за выводы и платежи.
        </li>
      </ul>
      <p>
        <br>
        <br>
        <strong>Version 2</strong>
        <br>
        <br>
      </p>
      <ul class="list-disc pl-8">
        <li>
          RevShare всегда рассчитывается как процент от <strong>общего NGR</strong> с учетом <strong>комиссий за депозиты и выводы</strong>.
        </li>
        <li>
          Формула расчета зависит от продуктов, выбранных в сделке (<strong>Casino, Sportsbook </strong>или<strong> оба продукта</strong>). Если выбран только один продукт (<strong>Casino </strong>или <strong>Sportsbook</strong>), значение второго продукта в формуле NGR <strong>принимается равным 0</strong>.
        </li>
        <li>
          GGR редактируемый под каждый продукт.
        </li>
        <li>
          Учитываются комиссии депозитов и выводов (на разные страны может устанавливаться разный процент).
        </li>
        <li>
          Расчет зависит от выбранного продукта.
        </li>
      </ul>
    </div>

    <div v-else>
      <p>
        <strong>Version 1</strong>
        <br>
        <br>
      </p>
      <ul class="list-disc pl-8">
        <li>
          RS calculation depends on which product NGR is specified in the deal: <strong>NGR Casino, NGR Sportsbook, or total NGR (NGR Casino + NGR Sportsbook)</strong>.
        </li>
        <li>
          Fixed platform coefficients are applied for <strong>Casino and Sportsbook</strong>.
        </li>
        <li>
          <strong>No separate fees</strong> for deposits or withdrawals are included in the calculation.
        </li>
      </ul>
      <p>
        <br>
        <br>
        <strong>Version 2</strong>
        <br>
        <br>
      </p>
      <ul class="list-disc pl-8">
        <li>
          RevShare is always calculated as a <strong>percentage of total NGR</strong>, including <strong>deposit and withdrawal fees</strong>.
        </li>
        <li>
          The calculation formula depends on the <strong>products selected in the deal (Casino, Sportsbook, or both)</strong>. If only one product is selected, the value of the second product in the NGR formula is <strong>set to 0</strong>.
        </li>
        <li>
          <strong>GGR can be adjusted separately for each product.</strong>
        </li>
        <li>
          <strong>Deposit and withdrawal fees are included</strong> (different percentages can be set for different countries).
        </li>
        <li>
          The calculation depends on the <strong>selected product(s)</strong>.
        </li>
      </ul>
    </div>
  </VDialog>
</template>
